<template>
  <el-dialog :visible.sync="visible" width="90%" append-to-body :close-on-click-modal="false" @closed="onClosed">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <workflow-doc-buttons biz-type="productionReturn" :biz-id="form.id" perm="production:productionReturn" :approve-status="String(form.approveStatus || '0')" @approve="approve(true)" @unapprove="approve(false)" @done="onWorkflowDone" />
            <el-button v-if="(isAuth('production:productionReturn:update') || isAuth('production:productionReturn:save')) && form.approveStatus !== '2'" type="primary" size="small" @click="readonly = false">修改</el-button>
            <el-button v-if="isAuth('production:productionReturn:delete') && form.approveStatus !== '2'" type="primary" size="small" @click="remove">删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px">
      <el-row :gutter="10">
        <el-col :span="6"><el-form-item label="退料单号"><el-input v-model="form.code" :disabled="formDisabled || !!form.id" placeholder="留空自动编号" /></el-form-item></el-col>
        <el-col :span="6"><el-form-item label="日期" prop="bizDate"><el-date-picker v-model="form.bizDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" :disabled="formDisabled" style="width:100%" /></el-form-item></el-col>
        <el-col :span="8">
          <el-form-item label="生产工单" prop="productionOrderId">
            <el-input :value="form.productionOrderCode" readonly placeholder="选择工单">
              <el-button v-if="!formDisabled" slot="append" @click="pickOrder">选择</el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="!formDisabled">
          <el-button type="primary" size="small" :disabled="!form.productionOrderId" @click="fillIssued">按已领带出</el-button>
        </el-col>
      </el-row>
      <el-table :data="form.lines" border :header-cell-style="headStyle">
        <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
        <el-table-column prop="materialCode" label="物料编码" min-width="120" header-align="center" align="left" />
        <el-table-column prop="materialName" label="物料名称" min-width="140" header-align="center" align="left" />
        <el-table-column prop="issuedQty" label="领取数量" width="100" header-align="center" align="left" />
        <el-table-column prop="returnedQty" label="已退数量" width="100" header-align="center" align="left" />
        <el-table-column prop="remainReturnQty" label="可退数量" width="100" header-align="center" align="left" />
        <el-table-column label="退料数量" width="130" header-align="center" align="left">
          <template slot-scope="s"><el-input-number v-model="s.row.quantity" :disabled="formDisabled" :min="0" :max="formDisabled ? Math.max(Number(s.row.quantity || 0), Number(s.row.remainReturnQty || 0)) : Number(s.row.remainReturnQty || 0)" :precision="2" size="small" style="width:100%" /></template>
        </el-table-column>
        <el-table-column label="入库库位" min-width="200" header-align="center" align="left">
          <template slot-scope="s"><warehouse-location-select v-model="s.row.wareHouseId" :disabled="formDisabled" size="small" /></template>
        </el-table-column>
        <el-table-column v-if="!formDisabled" label="操作" width="70" header-align="center" align="center">
          <template slot-scope="s"><el-button type="text" size="small" @click="form.lines.splice(s.$index, 1)">删除</el-button></template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formDisabled" type="primary" @click="save">保存</el-button>
    </span>
    <el-dialog title="选择生产工单" :visible.sync="orderDlg" width="700px" append-to-body>
      <el-table :data="orders" border :header-cell-style="headStyle" @row-click="selectOrder">
        <el-table-column prop="productionOrderCode" label="工单号" min-width="140" />
        <el-table-column prop="materialCode" label="成品编码" min-width="120" />
        <el-table-column prop="orderStatus" label="状态" width="90">
          <template slot-scope="s">{{ s.row.orderStatus === '1' ? '已下达' : s.row.orderStatus === '3' ? '已完工' : (s.row.orderStatus || '') }}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </el-dialog>
</template>

<script>
import WorkflowDocButtons from '../../components/WorkflowDocButtons.vue'
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import WarehouseLocationSelect from '../../components/WarehouseLocationSelect.vue'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' 00:00:00'
}

export default {
  name: 'ProductionReturnAddOrUpdate',
  components: { WorkflowDocButtons, WarehouseLocationSelect },
  data() {
    return {
      visible: false,
      readonly: false,
      orderDlg: false,
      orders: [],
      ordersRequestId: 0,
      permCodes: [],
      form: { lines: [], productionOrderCode: '' },
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },
      rules: {
        bizDate: [{ required: true, message: '日期不能为空', trigger: 'change' }],
        productionOrderId: [{ required: true, message: '请选择生产工单', trigger: 'change' }]
      }
    }
  },
  computed: {
    formDisabled() { return this.readonly || String(this.form.approveStatus) === '2' },
    showViewToolbar() { return this.readonly && !!this.form.id },
    dialogTitle() {
      if (this.readonly) return '退料详情'
      return this.form.id ? '修改退料' : '新增退料'
    }
  },
  created() {
    this.loadPerms()
    this.loadOrders()
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    loadOrders(includeId) {
      const include = includeId || (this.form && this.form.productionOrderId) || ''
      const requestId = ++this.ordersRequestId
      return request.get('/production/order/ordersForBiz', { params: { includeProductionOrderId: include } })
        .then(res => { if (requestId === this.ordersRequestId) this.orders = res.data || [] })
        .catch(() => { if (requestId === this.ordersRequestId) this.orders = [] })
    },
    pickOrder() {
      this.orderDlg = true
      this.loadOrders(this.form.productionOrderId)
    },
    selectOrder(row) {
      if (!row) return
      this.form.productionOrderId = row.productionOrderId
      this.form.productionOrderCode = row.productionOrderCode || ''
      this.form.lines = []
      this.orderDlg = false
      this.$nextTick(() => this.fillIssued())
    },
    onWorkflowDone() {
      this.$emit('refreshDataList')
      if (this.form && this.form.id) this.init(this.form.id, true)
    },
    onClosed() {
      this.readonly = false
      this.orderDlg = false
      this.form = { lines: [], productionOrderCode: '' }
    },
    init(idOrRow, readonly) {
      this.visible = true
      this.readonly = !!readonly
      if (this.readonly && idOrRow) {
        const openView = prefill => {
          const order = this.orders.find(item => item.productionOrderCode === prefill.productionOrderCode)
          const bizDate = prefill.bizDate && String(prefill.bizDate).length <= 10 ? prefill.bizDate + ' 00:00:00' : (prefill.bizDate || '')
          this.form = { id: prefill.id, code: prefill.code || '', bizDate, productionOrderId: prefill.productionOrderId || (order ? order.productionOrderId : ''), productionOrderCode: prefill.productionOrderCode || (order ? order.productionOrderCode : ''), approveStatus: String(prefill.approveStatus || '0'), remark: prefill.remark || '', lines: [] }
          this.loadOrders(this.form.productionOrderId)
          request.get('/production/return/lines', { params: { id: prefill.id } }).then(res => {
            this.form.lines = res.data || []
            this.mergeIssued()
          }).catch(() => {})
        }
        const id = typeof idOrRow === 'object' ? idOrRow.id : idOrRow
        if (id) {
          request.get('/production/return/info', { params: { id } }).then(res => {
            openView(res.data || (typeof idOrRow === 'object' ? idOrRow : { id }))
          }).catch(() => { openView(typeof idOrRow === 'object' ? idOrRow : { id }) })
        }
        return
      }
      const prefill = idOrRow && typeof idOrRow === 'object' ? idOrRow : null
      this.form = { code: '', bizDate: today(), productionOrderId: (prefill && prefill.productionOrderId) || '', productionOrderCode: (prefill && prefill.productionOrderCode) || '', remark: '', lines: [] }
      if (this.form.productionOrderId) {
        const orderId = this.form.productionOrderId
        this.loadOrders(orderId).then(() => {
          if (!this.visible || this.form.productionOrderId !== orderId || this.form.productionOrderCode) return
          const hit = this.orders.find(order => order.productionOrderId === orderId)
          if (hit) this.form.productionOrderCode = hit.productionOrderCode || ''
        })
      }
    },
    fillIssued() {
      request.get('/production/return/issuedMaterials', { params: { productionOrderId: this.form.productionOrderId, excludeReturnId: this.form.id || '' } }).then(res => {
        this.form.lines = (res.data || []).map(row => Object.assign({ quantity: Number(row.remainReturnQty || 0) }, row))
        if (!this.form.lines.length) this.$message.warning('没有可退物料')
      }).catch(() => {})
    },
    mergeIssued() {
      if (!this.form.productionOrderId) return
      request.get('/production/return/issuedMaterials', { params: { productionOrderId: this.form.productionOrderId, excludeReturnId: this.form.id || '' } }).then(res => {
        const map = {}
        ;(res.data || []).forEach(row => { map[row.materialId] = row })
        this.form.lines = (this.form.lines || []).map(line => Object.assign({}, map[line.materialId] || {}, line, { quantity: Number(line.quantity || 0) }))
      }).catch(() => {})
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        const lines = (this.form.lines || []).filter(line => line.materialId && Number(line.quantity) > 0)
        if (!lines.length) { this.$message.warning('请按已领带出并填写退料数量'); return }
        request.post('/production/return/save', {
          id: this.form.id, code: this.form.code, bizDate: this.form.bizDate, productionOrderId: this.form.productionOrderId, remark: this.form.remark,
          lines: lines.map(line => ({ materialId: line.materialId, quantity: line.quantity, wareHouseId: line.wareHouseId, remark: '' }))
        }).then(() => { this.$message.success('保存成功'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})
      })
    },
    approve(yes) {
      request.post(yes ? '/production/return/approve' : '/production/return/unapprove', { id: this.form.id }).then(() => { this.$message.success('操作成功'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})
    },
    remove() {
      this.$confirm('确定删除这张未审核退料单?', '提示', { type: 'warning' }).then(() => {
        request.post('/production/return/delete', { id: this.form.id }).then(() => { this.$message.success('已删除'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
.doc-dialog-actions .el-button { margin-left: 0; }
</style>
